import { util } from 'pevueglobal'
import locStore from 'store2'
import { graphdata, getGraphUrl, setReportStatus, resetreportstatus, setGraphdata } from '../XVgraphcontrol.js'
let lstore = locStore.namespace('Spe020PrStatusoverzicht')

// state
const state = {
  labels: [],
  allTargets: [],
  targetgroup: [],
  statusTargetberekening: null,
  // lstore: null,
  showheader: true,
  graphdata: []
}

// getters
const getters = {
  labels: state => state.labels,
  allTargets: state => state.allTargets,
  targetgroup: state => state.targetgroup,
  statusTargetberekening: state => state.statusTargetberekening,
  showheader: state => state.showheader,
  graphdata: graphdata('graphdata')
}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [1232, 2258, 2259, 2260, 7493, 8772, 9181, 15206, 18212]
    dispatch('gettranslations', textIDs, { root: true })
  },
  getGraphUrl: getGraphUrl('setReportStatus'),
  getStatus: async ({ commit, dispatch }) => {
    const statusDS = await util.getDataApi('prof/PEapi_SPE020_PR_StatusCheck')
    // 1 = nog een keer
    state.statusTargetberekening = statusDS.ds.data0[0].statusTargetberekening
    if (statusDS.ds.data0[0].statusTargetberekening === 1) {
      setTimeout(function() {
        dispatch('getStatus')
      }, 1000)
      // setTimeout(dispatch('getStatus'), 1000) -> dit gaf een error maar voluitgeschreven niet. (regels hier boven met setTimeout)
    } else {
      dispatch('getTargets')
    }
  },
  getTargets: async ({ commit, dispatch }) => {
    const myTargets = await util.getDataApi('prof/PEapi_SPE020_PR_Statusoverzicht')

    // util.UsetCookie('FromSPE062', 'false')

    state.statusTargetberekening = myTargets.ds.data0[0].statusTargetberekening
    if (myTargets.ds.data0[0].statusTargetberekening === 1) {
      dispatch('getStatus')
    } else {
      let redirectlink = myTargets.ds.data1[0].redirectDirectlyTo
      if (myTargets.ds.data1[0].redirectDirectlyTo !== null) {
        if (redirectlink.indexOf('/WizardSubmitDossier/') !== -1) {
          if (util.UgetCookie('FromSPE062') === 'true') {
            util.UsetCookie('FromSPE062', 'false')
            window.location = redirectlink
          }
        } else {
          util.UsetCookie('FromSPE062', 'false')
          window.location = redirectlink
        }
      }

      let sPE060textID = myTargets.ds.data2.filter(t => {
        return t.spE060LinkTextID !== null
      })
      let wizardDossierLinkTextID = myTargets.ds.data2.filter(t => {
        return t.wizardDossierLinkTextID !== null
      })
      let wizardDossierLinkTextIDUniek = [...new Set(wizardDossierLinkTextID.map(item => item.wizardDossierLinkTextID))]
      let sPE060TextIDUniek = [...new Set(sPE060textID.map(item => item.spE060LinkTextID))]
      // arrays samenvoegen door middel van "destructuring assignment syntax"
      let textIDs = [...sPE060TextIDUniek, ...wizardDossierLinkTextIDUniek, 8772]
      // dispatch voert hier al de functie gettranslations uit waarbij de array met text id's wordt meegegeven.
      dispatch('gettranslations', textIDs, { root: true })
      commit('setMyTargets', myTargets)
      commit('stopLoading', null, { root: true })
    }
    const graphInput = {
      pagename: 'SPE020_PR_Statusoverzicht.aspx',
      clientid: ''
    }
    const [graphdata] = await Promise.all([
      util.getDataApi('allroles/PEapi_GraphControl_Get_Available_Graphs', graphInput)
      // util.GetXVTableData('prof/PEapi_SPE021_PR_PEActiviteiten_XVTable')
    ])

    commit('setGraphdata', graphdata)
  }
}

// mutations
const mutations = {
  setReportStatus: setReportStatus('graphdata'),
  resetreportstatus: resetreportstatus('graphdata'),
  setGraphdata: setGraphdata('graphdata'),
  setMyTargets(state, myTargets) {
    state.labels = myTargets.ds.data1[0]

    let allTargets = myTargets.ds.data2
    let primaryheaderIDset = null
    let lastinrowID = null
    let targetindex = 0
    let StateToggleTargetRow
    if (lstore.session('StateToggleTargetRow')) {
      StateToggleTargetRow = lstore.session('StateToggleTargetRow')
    } else {
      StateToggleTargetRow = []
    }
    let StateToggleGroupTargetRow
    if (lstore.session('StateToggleGroupTargetRow')) {
      StateToggleGroupTargetRow = lstore.session('StateToggleGroupTargetRow')
    } else {
      StateToggleGroupTargetRow = []
    }
    allTargets.forEach(target => {
      target.targetgroup = {
        firstTargetofGroup: null,
        lastTargetofGroup: null,
        togglerow: false,
        targetID: targetindex,
        subsubheadericondown: true,
        togglegrouprow: false
      }
      targetindex++
      if (target.targetCodeExpand === 1 || target.wizardDossierLink !== null) {
        // if (target.targetCodeExpand === 1 || target.spE060Link !== null || target.wizardDossierLink !== null) { aangepast. ook bijv dossier behandel row stond standaard open geklapt.
        if (!StateToggleTargetRow.includes(target.targetgroup.targetID)) {
          // targetrows en grouptargetrows die al open moeten staan bij openen van de pagina:
          StateToggleTargetRow.push(target.targetgroup.targetID)
          StateToggleGroupTargetRow.push(target.targetgroup.targetID)
        }
        lstore.session('StateToggleTargetRow', StateToggleTargetRow)
        target.targetgroup.togglerow = true
      }
      if (StateToggleTargetRow) {
        StateToggleTargetRow.forEach(id => {
          if (target.targetgroup.targetID === id) {
            target.targetgroup.togglerow = true
          }
        })
      }
    })
    allTargets
      .filter(t => {
        return t.tblProfGroupTargetGroupingID !== null
      })
      .forEach(target => {
        target.targetgroup.data = myTargets.ds.data3.filter(
          tg => tg.tblProfGroupTargetGroupingID === target.tblProfGroupTargetGroupingID
        )[0]
        // 0 = Standaard ingeklapt, 1 = Standaard uitgeklapt
        if (target.targetgroup.data.tblProfGroupTargetGroupingCodeExpand === 1) {
          if (StateToggleGroupTargetRow) {
            if (!StateToggleGroupTargetRow.includes(target.targetgroup.targetID)) {
              StateToggleGroupTargetRow.push(target.targetgroup.targetID)
            }
          }
          lstore.session('StateToggleGroupTargetRow', StateToggleGroupTargetRow)
        }

        if (StateToggleGroupTargetRow) {
          StateToggleGroupTargetRow.forEach(id => {
            if (target.targetgroup.targetID === id) {
              target.targetgroup.togglegrouprow = true
            }
          })
        }

        // afvangen of het target de eerste is van de targetgroep
        if (primaryheaderIDset === null) {
          primaryheaderIDset = target.tblProfGroupTargetGroupingID
          target.targetgroup.firstTargetofGroup = true
        } else if (primaryheaderIDset !== target.tblProfGroupTargetGroupingID) {
          primaryheaderIDset = target.tblProfGroupTargetGroupingID
          target.targetgroup.firstTargetofGroup = true
        } else {
          target.targetgroup.firstTargetofGroup = false
        }
        if (target.targetgroup.groupHeaderText !== '') {
          state.showheader = false
        }
      })

    const reversetargets = allTargets.slice().reverse()

    // console.log(reversetargets)
    // afvangen of het target de laatste is van de targetgroep
    // lastinrowID
    reversetargets
      .filter(t => {
        return t.tblProfGroupTargetGroupingID !== null
      })
      .forEach(target => {
        target.targetgroup.data = myTargets.ds.data3.filter(
          tg => tg.tblProfGroupTargetGroupingID === target.tblProfGroupTargetGroupingID
        )[0]

        if (lastinrowID === null) {
          lastinrowID = target.tblProfGroupTargetGroupingID
          target.targetgroup.lastTargetofGroup = true
        } else if (lastinrowID !== target.tblProfGroupTargetGroupingID) {
          lastinrowID = target.tblProfGroupTargetGroupingID
          target.targetgroup.lastTargetofGroup = true
        } else {
          target.targetgroup.lastTargetofGroup = false
        }
      })
    // console.log(reversetargets)
    state.allTargets = allTargets
    state.targetgroup = myTargets.ds.data3
  },
  setToggleTargetRow(state, id) {
    let tt = state.allTargets.filter(t => t.targetgroup.targetID === id)[0]
    tt.targetgroup.togglerow = !tt.targetgroup.togglerow
    tt.targetgroup.subsubheadericondown = !tt.targetgroup.subsubheadericondown
    let StateToggleTargetRow = lstore.session('StateToggleTargetRow')
    if (!StateToggleTargetRow) {
      StateToggleTargetRow = []
    }
    if (StateToggleTargetRow.indexOf(id) === -1) {
      StateToggleTargetRow.push(id)
    } else {
      StateToggleTargetRow.splice(StateToggleTargetRow.indexOf(id), 1)
    }
    lstore.session('StateToggleTargetRow', StateToggleTargetRow)
  },

  setTogglegrouprow(state, groupid) {
    let StateToggleGroupTargetRow = lstore.session('StateToggleGroupTargetRow')
    state.allTargets
      .filter(t => t.tblProfGroupTargetGroupingID === groupid)
      .forEach(target => {
        target.targetgroup.togglegrouprow = !target.targetgroup.togglegrouprow
        if (!StateToggleGroupTargetRow) {
          StateToggleGroupTargetRow = []
        }
        if (StateToggleGroupTargetRow.indexOf(target.targetgroup.targetID) === -1) {
          StateToggleGroupTargetRow.push(target.targetgroup.targetID)
        } else {
          StateToggleGroupTargetRow.splice(StateToggleGroupTargetRow.indexOf(target.targetgroup.targetID), 1)
        }
      })
    lstore.session('StateToggleGroupTargetRow', StateToggleGroupTargetRow)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
